import { useEffect, useMemo, useState, useContext } from 'react';
import { AppContext } from 'Context';
import InputGrid from '../input-grid';
import InputField from '../input-field';
import { parseNumber } from '../parse-number';
import styles from './index.module.css';

function getCardNumber(value) {
  return value.replace(/(\d{4})/g, '$1 ').replace(/(^\s+|\s+$)/, '');
}

function getExpirationDate(value) {
  if (!/^\d{0,2}\/?\d{0,2}$/.test(value)) {
    return;
  }

  let input = value;

  if (/^\d{3,}$/.test(input)) {
    input = input.match(new RegExp('.{1,2}', 'g')).join('/');
  }

  return input;
}

function CredentialField({
  onCardNumberChange,
  onCvvNumberChange,
  onExpirationDateChange,
  setValidity }) {
  const { langText, cardNumber, setCardNumber, cvvNumber, setCvvNumber, expirationDate, setExpirationDate } = useContext(AppContext);
  const addCardText = langText?.settings?.billPayment?.paymentMethod?.cardDetails;

  const cardNumberIsValid = useMemo(() => (cardNumber.length === 19), [cardNumber]);
  const cvvNumberIsValid = useMemo(() => (cvvNumber.length >= 3), [cvvNumber]);
  const expirationDateIsValid = useMemo(() => (expirationDate.length === 5), [expirationDate]);

  useEffect(() => {
    setValidity(cardNumberIsValid && cvvNumberIsValid && expirationDateIsValid);
  }, [cardNumberIsValid, cvvNumberIsValid, expirationDateIsValid]);

  return (
    <InputGrid>
      <InputField
        className={styles.cardNumber}
        maxLength={19}
        onChange={(value) => {
          const parsedValue = parseNumber(value);

          setCardNumber(getCardNumber(parsedValue));
          onCardNumberChange(parsedValue);
        }}
        placeholder={addCardText?.cardNoPlaceholder || 'Card number'}
        type="text"
        value={cardNumber}
      />
      <InputField
        className={styles.expirationDate}
        maxLength={5}
        onChange={(value) => {
          const parsedValue = getExpirationDate(parseNumber(value));

          setExpirationDate(parsedValue);
          onExpirationDateChange(parsedValue);
        }}
        placeholder={addCardText?.datePlaceholder || 'MM/YY'}
        type="text"
        value={expirationDate}
      />
      <InputField
        className={styles.cvvNumber}
        maxLength={4}
        onChange={(value) => {
          const parsedValue = parseNumber(value);

          setCvvNumber(parsedValue);
          onCvvNumberChange(parsedValue);
        }}
        placeholder={addCardText?.cvvPlaceholder || 'CVV'}
        type="text"
        value={cvvNumber}
      />
    </InputGrid>
  );
}

export default CredentialField;
